/**
 * Recognises the rejection of a distributor code that another supplier under
 * the same hierarchy root already uses.
 *
 * `supplierService` raises `DuplicateSupplierCodeError` and answers it as a 400
 * with a constant message. Its `BAD_USER_INPUT` code is shared with every other
 * bad request, so the message is the only thing that names this rule. Only a
 * changed code is checked, so re-saving a stored code never hits this.
 */

/**
 * Matched as a substring: AppSync and Apollo may both wrap the service
 * message, so an equality check would miss it.
 */
const DUPLICATE_SUPPLIER_CODE_TEXT = 'already uses this code';

export const DUPLICATE_SUPPLIER_CODE_MESSAGE =
  'This code is already in use. Enter a different one.';

/**
 * Structural rather than `instanceof Error`: under `errorPolicy: 'all'` a
 * GraphQL error is the plain object parsed from the response.
 */
export const isDuplicateSupplierCodeError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'message' in error &&
  typeof error.message === 'string' &&
  error.message.includes(DUPLICATE_SUPPLIER_CODE_TEXT);
